import { render } from "./PoolTable.vue?vue&type=template&id=3b220a84&scoped=true&ts=true"
import script from "./PoolTable.vue?vue&type=script&lang=ts"
export * from "./PoolTable.vue?vue&type=script&lang=ts"

import "./PoolTable.vue?vue&type=style&index=0&id=3b220a84&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b220a84"]])

export default __exports__